import { postAuthDataCall } from '../utils';

export const addQuestionAnswerApi = async (payload) => {
    const resp = await postAuthDataCall(`/v1/question_answers`, payload);
    return resp;
};
